import React, { Component } from 'react'

import { chainesLocales } from './../include/chainesLocales';

import './footer.css';

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    get labels() {
        return chainesLocales['Footer'][this.props.lang];
    }

    render() {
        return (
            <footer className="Footer py-2 py-lg-3">
                <div>
                    <a className="lienQc" href={this.labels.urlGouvQc} target="_blank" rel="noopener noreferrer">
                        <img className="logoQc" src={`/web2/static/images/QUEBir${this.props.logoQcB ? "_black" : ""}.svg`} alt={this.labels.altLogoQc} />
                    </a>
                </div>
                <div>
                    <a href={this.labels.urlCopyright} target="_blank" rel="noopener noreferrer">{this.labels.textCopy}&nbsp;{new Date().getFullYear()}</a>
                </div>
            </footer>
        );
    }
}

export default Footer;